import {http} from './config';
export default{
    listarPrincipals:()=>{
        return http.get('api/principals');
    },
    save:(principal)=>{
        return http.post('api/principal',principal)
    },
    delete:(principal)=>{
        return http.delete('api/principal/'+principal.id)
    },
    update:(principal)=>{

            return http({method:'PUT', url:('/api/principal/'+principal.id), data:principal})
    },
    listarPrincipalsOpcion:(principal)=>{
        return http.get('/api/principal/busqueda_por_opcion/'+principal.id);
    },
    //para busqueda de perfil por visitante.
    listarPrincipalsOpcionPorIdentificador:(identificador)=>{
        return http.get('/api/principal/busqueda_por_opcion_identificador/'+identificador);
    },

    //para ver si esta activo
    isActive:(identificador)=>{
        return http.get('/api/principal/is_active/'+identificador);
    },
    obtenerPrincipalPorUserPorIdentificador:(identificador)=>{
        return http.get('/api/principal/busqueda_por_usuario_identificador/'+identificador);
    },
    listarPrincipalsOpcionPorIdentificadorSinVer:(identificador)=>{
        return http.get('/api/principal/busqueda_por_usuario_identificador_sinver/'+identificador,{
            params: { _t: new Date().getTime() } // Agrega una marca de tiempo única
          });
    },

    verificarPrincipal(principal){
            return http.post('api/principal/verificar_principal', principal)
    },


    
    obtenerPrincipalPorUserPorEmail:(email)=>{
        return http.get('/api/principal/busqueda_por_usuario_email/'+email);
    },

    recuperarFoto(principal){
            return http.post('api/principal/recuperar_foto', principal)
    },

    
    
    
}
